// enroll.js
import { select, selectAll } from '../shared/utils/dom';

/**
 * Managing Subscription Checkboxes
 */
const el = select('[data-vue-app="manage-subscriptions"]');
let boxes = selectAll('[data-vue-app="manage-subscriptions"] input[type="checkbox"]');
let boxTruths = [];
for (let i = 0; i < boxes.length; i += 1) {
  boxTruths.push(boxes[i].checked);
}

if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    data: {
      optOutOfAll: false,
      checkboxes: boxes,
      boxTruths,
    },
    methods: {
      saveState(e) {
        if (e.target.checked === true && e.target.id === 'all') {
          this.uncheckAll();
        } else if (e.target.checked === false && e.target.id === 'all') {
          this.recheck();
        } else {
          boxTruths = [];
          boxes = selectAll('[data-vue-app="manage-subscriptions"] input[type="checkbox"]');
          for (let i = 0; i < boxes.length; i += 1) {
            boxTruths.push(boxes[i].checked);
          }

          this.boxTruths = boxTruths;
          this.optOutOfAll = false;
        }
      },
      uncheckAll() {
        boxTruths = [];
        boxes = selectAll('[data-vue-app="manage-subscriptions"] input[type="checkbox"]');
        this.checkboxes = boxes;

        for (let i = 0; i < boxes.length; i += 1) {
          boxTruths.push(boxes[i].checked);
        }

        this.boxTruths = boxTruths;
        let initCount = 1;
        let totalCheckboxCount = this.checkboxes.length;

        if (window.enableAlertsAndSubscriptionsForAll) {
          initCount = 0;
          totalCheckboxCount = this.checkboxes.length - 1;
        }

        for (let i = initCount; i < totalCheckboxCount; i += 1) {
          const boxID = `#${this.checkboxes[i].id}`;
          const box1 = select(boxID);
          box1.checked = false;
        }
      },
      recheck() {
        let initCount = 1;
        let totalCheckboxCount = this.boxTruths.length;

        if (window.enableAlertsAndSubscriptionsForAll) {
          initCount = 0;
          totalCheckboxCount = this.boxTruths.length - 1;
        }

        for (let i = initCount; i < totalCheckboxCount; i += 1) {
          const boxID = `#${this.checkboxes[i].id}`;
          const box = select(boxID);
          if (this.boxTruths[i] === true) {
            box.checked = true;
          }
        }
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/manage-subscriptions.js